import styled, { css } from 'styled-components'
import { ICentraThemeColors } from 'components/styles/variables'

export interface ITitleStyle {
  $color?: keyof ICentraThemeColors
  ellipsis?: boolean
  uppercase?: boolean
  align?: 'left' | 'center' | 'right'
}

const globalTitleStyle = css<ITitleStyle>(
  ({ theme, ellipsis, $color, uppercase, align }) => css`
    ${ellipsis &&
    css`
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `}

    ${$color &&
    css`
      color: ${theme.colors[$color]};
    `}

    ${uppercase &&
    css`
      text-transform: uppercase;
    `}

    ${align &&
    css`
      text-align: ${align};
    `}

    svg {
      margin-right: 8px;
      display: inline-block;
      vertical-align: middle;
    }
  `
)

export const H1 = styled.h1`
  ${({ theme }) => css`
    font-weight: 800;
    font-size: 30px;
    ${globalTitleStyle};

    ${theme.breakpoints.up(1024)} {
      font-size: 46px;
      line-height: 1.4;
    }
  `}
`

export const H2 = styled.h2`
  ${({ theme }) => css`
    font-weight: 800;
    font-size: 24px;
    ${globalTitleStyle};

    ${theme.breakpoints.up(1024)} {
      font-size: 36px;
      line-height: 1.4;
    }
  `}
`

export const H3 = styled.h3`
  ${({ theme }) => css`
    font-weight: 800;
    font-size: 20px;
    ${globalTitleStyle};

    ${theme.breakpoints.up(1024)} {
      font-size: 24px;
    }
  `}
`

export const H4 = styled.h4`
  ${({ theme }) => css`
    font-weight: bold;
    font-size: 16px;
    ${globalTitleStyle};

    ${theme.breakpoints.up(1024)} {
      font-size: 20px;
      line-height: 1.4;
    }
  `}
`

export const H5 = styled.h5`
  ${({ theme }) => css`
    font-weight: 500;
    font-size: 10px;
    line-height: 1.3;
    letter-spacing: 1px;
    ${globalTitleStyle};

    ${theme.breakpoints.up(1024)} {
      font-size: 12px;
      line-height: 1.8;
    }
  `}
`
